module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GY - Guyana.3c1eb541.svg";